import React from "react";

function PriorityCellRenderer(params) {
  const celldata = params.colDef?.options;
  if (celldata) {
    if (Array.isArray(params.value)) {
      try {
        if (!Array.isArray(params.value)) {
          const vall = params.value?.split(",");
          const cellvalue = params.value?.[0] ? params.value[0] : params.value;

          const data = celldata.filter((item) => vall.includes(item._id || item.id));

          if (data) {
            if (
              params.data.completed == "true" ||
              params.data.completed == true
            ) {
              return (
                <span className="strike-out">{data.option_name.join(",")}</span>
              );
            }
            return data.option_name.join(",");
          }
        } else {
          if (params.value) {
            const cellvalue = params?.value?.[0]
              ? params.value[0]
              : params.value;

            const data = celldata.find((item) => (item._id || item.id) === cellvalue);
            if (data) {
              if (
                params.data.completed == "true" ||
                params.data.completed == true
              ) {
                return <span className="strike-out">{data.option_name}</span>;
              }
              return data.option_name;
            }
          } else {
            return params.value.option_name ? params.value.option_name : "";
          }
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        if (!Array.isArray(params.value) && typeof params.value !== "object") {
          const vall = params.value?.split(",");
          const data = celldata
            .filter((item) => vall?.includes(item._id || item.id))
            .map((ii) => ii.option_name);
          if (data) {
            if (
              params.data.completed == "true" ||
              params.data.completed == true
            ) {
              return <span className="strike-out">{data.join(",")}</span>;
            }
            return data.join(",");
          }
        } else {
          const data = celldata.find((item) => (item._id || item.id) === params?.value);
          if (data) {
            return data.option_name;
          } else {
            return params.value.option_name;
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  } else {
    if (params.api.columnModel?.rowGroupColumns[0] !== undefined) {
      const options =
        params.api.columnModel?.rowGroupColumns[0].colDef?.options;

      if (Array.isArray(options)) {
        return options.find((item) => (item._id || item.id) === params.value)?.option_name;
      } else {
        return params.value;
      }
    } else {
      return params?.value;
    }
  }
}
export default PriorityCellRenderer;
